module.exports = __webpack_public_path__ + "assets/img/win10warn_en.6dc696c1.png";